import React, { Fragment, useEffect, useState } from 'react';
import Common from '../../../Shared/Common';
import { Container, Row, Col } from 'reactstrap';

import './../Resources/css/block_top.css'
import Block from '../../../Controls/Scafolding/Block';
import { Button } from 'bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft, faFish } from '@fortawesome/free-solid-svg-icons';
import img from '../Resources/Images/top_background.jpg';

const Top = (props) => {

    const [blockName, setBlockName] = useState("");

    useEffect(() => {
        setBlockName(props.name);
        Common.traceInit("Block " + blockName);
    });

    return (

        <Block name="top" isAlt={true}>

            <Row className="top-inner-lg d-none d-sm-block">
                <Col lg="12" />
            </Row>

            <Row className="top-inner-xs d-block d-sm-none">
                <Col lg="12" />
            </Row>

            <Row className="">
                <Col lg="12">
                    <Container>
                        <Row>
                            <Col lg="12" className="d-none d-sm-block top-message top-message-lg">
                                Gwynneville Bakery & Co.
                            </Col>

                            <Col lg="12" className="d-none d-sm-block low-message low-message-lg">
                                handcrafted bread, pastries & cakes
                            </Col>

                            <Col lg="12" className="d-block d-sm-none d-flex top-message top-message-xs">
                                Gwynneville Bakery & Co.
                            </Col>

                            <Col lg="12" className="d-block d-sm-none low-message low-message-xs">
                                handcrafted bread, pastries & cakes
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>

            <Row className="top-inner-bottom">
            </Row>
        </Block>
    );
};
export default Top;


